import pug from 'javascripts/search/templates/coauthor_search_cant_find.jst.pug';
window.JST = window.JST || {};
window.JST['search/templates/coauthor_search_cant_find'] = pug;
